// src/api/config.js



// export const REACT_APP_SOCKET_URL ="http://localhost:5000"
// export const API_BASE_URL ="http://localhost:5000"

export const REACT_APP_SOCKET_URL = process.env.REACT_APP_SOCKET_URL
export const API_BASE_URL =process.env.REACT_APP_API_URL
export const REACT_APP_GOOGLE_CLIENT_ID =process.env.REACT_APP_GOOGLE_CLIENT_ID